import React, {useEffect, useRef, useState} from 'react';
import styles from './styles';
import {DataTableContext} from '../../Utils/DataTableContext';
import {ModalContainer, Form} from '@xpertdox_js/xdcomponents';


const HeaderModal = props => {

  const {controller, setController} = React.useContext(DataTableContext);
  const [showModal, setShowModal] = useState(false);
  const isSearching = controller.searchingHeader !== null && controller.searchActive;
  const [formState, setFormState] = useState({});
  const formRef = useRef({dt_default_formSearch: ''});

  useEffect(() => {
    if (isSearching && !showModal) {
      setShowModal(true)
      formRef.current.dt_default_formSearch = ''
    }
  }, [controller.searchActive, controller.searchingHeader])
    // if (isSearching && !showModal) setShowModal(true);

  useEffect(() => {
    if (controller.queryString === '') formRef.current.dt_default_formSearch = '';
  }, [controller.queryString])

  if (controller.searchingHeader !== null && formRef.current.dt_default_formSearch !== formState.dt_default_formSearch) {
    const searchVal = formState.dt_default_form_search;
    if (searchVal !== undefined && searchVal !== '')
    formRef.current.dt_default_formSearch = searchVal;
    const refSearchVal = formRef.current.dt_default_formSearch;
    if (refSearchVal !== controller.queryString) {
      // controller.queryString = refSearchVal;
      controller.queryData(refSearchVal)
      controller.render();
    }

  }

  const closeModal = () => {
    controller.searchActive = false;
    controller.render();
    setShowModal(false);
  }

  const resetController = () => {
    if (controller.queryString === '') {
      controller.searchingHeader = null;
      controller.reset();
      controller.render();
    }
  }

  const formSettings = [
    {
      type: 'text',
      label: 'Search Column',
      placeHolder: 'Searching...',
      id: 'dt_default_form_search',
      attributes: {
        autoFocus: true,
      }
    }
  ]


  return(
    <ModalContainer
      showOverlay={showModal}
      open={showModal}
      close={closeModal}
      wrapStyles={styles.container}
      callback={!showModal ? resetController : null}
      height={'100px'}
      width={'386px'}
    >
      <Form
        state={{formState: formState, setFormState: setFormState}}
        settings={formSettings}
        submitable={false}
      />
    </ModalContainer>
  )
}

export default HeaderModal;
